import { Navigate, useLocation } from 'react-router-dom';

import { internalConsolePathFor } from '@/config/routes';
import { unscopedLandingRoute } from '@/services/org-data';

/**
 * DV-3520: the internal console moved from `/account` to `/internal`. This
 * sends an old link, bookmark or pasted ticket URL to its new address, with
 * its query string and hash. `replace`, so Back doesn't land on the old URL
 * and bounce forward again.
 *
 * A bare `/account` goes to the bare `/internal`, which `ConsoleRootRedirect`
 * sends on to the user's landing: two `replace` hops.
 *
 * Mounted outside `PrivateRoute`: the destination's own guard row decides who
 * may see it. `route-guards.ts` keeps an `/account` row only so the auth
 * bootstrap lets these URLs through.
 */
export function LegacyConsoleRedirect() {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={`${internalConsolePathFor(pathname)}${search}${hash}`} replace />;
}

/**
 * The bare console root has no page of its own: it sends each role where it
 * lands without an account (the accounts list, Global Orders, or the org
 * picker). A component, not an inline `<Navigate>`, because `appRoutes` is
 * built once at module load and the role is only known after login.
 */
export function ConsoleRootRedirect() {
  return <Navigate to={unscopedLandingRoute()} replace />;
}

export default LegacyConsoleRedirect;
